import { Skeleton, Column, Row } from 'components/Blocks';

export function LoadingComment() {
  return (
    <Row alignItems="flex-start">
      <Skeleton height={40} width={40} circle />

      <Column gap="2">
        <Row justifyContent="space-between">
          <Skeleton height={18} width={84} />

          <Skeleton height={18} width={120} />
        </Row>

        <Skeleton height={42} width="100%" />
      </Column>
    </Row>
  );
}
